import message from './message'
import layer from './layer'

export default {
    init: (isPC) => {
        $(document).on('click', '.summitBtn', function () {
            if (!($('.summitBtn').hasClass('disable'))) {
                _request(isPC)
            }
        })
    },
    show: (isPC) => {
        if (isPC === 2) {
            // layer.showPCFinished()
            layer.showPCForm()
        } else {
            // layer.showMobileFinished()
            layer.showMobileForm()
        }
        _buttonCheck()
    },
}

function _request (isPC) {
    let checkResult = _formCheck()
    if (checkResult.code && checkResult.code === '0') {
        // 检查无误，提交请求
        if (isPC === 2) {
            layer.removePCForm()
        } else {
            layer.removeMobileForm()
        }

        $.ajax({
            url: '/business/apply',
            type: 'POST',
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify(checkResult.res),
            success: function (data) {
                console.log(data);
                if (!data.success) {
                    message.showErrorBox(data.msg, 2000)
                } else {
                    if (isPC === 2) {
                        layer.showPCFinished()
                    } else {
                        layer.showMobileFinished()
                    }

                }
                if (isPC === 2) {
                    $('.applyBtn-web').removeClass('disable')
                } else {
                    $('.applyBtn button').removeClass('disable')
                }
            },
            error: function () {
                message.showErrorBox('网络错误', 2000)
                if (isPC === 2) {
                    $('.applyBtn-web').removeClass('disable')
                } else {
                    $('.applyBtn button').removeClass('disable')
                }
            },
            complete: function () {
                if (isPC === 2) {
                    $('.applyBtn-web').removeClass('disable')
                } else {
                    $('.applyBtn button').removeClass('disable')
                }
            }
        })
    } else {
        message.showErrorBox(checkResult, 2000)
    }
}

function _formCheck () {
    let orgName = $('.orgNameInput').val()
    let name = $('.nameInput').val()
    let duty = $('.dutyInput').val()
    if (orgName && orgName.length > 30) {
        return '机构/团队名称不能超过30个字'
    }
    if (name && name.length > 30) {
        return '您的姓名不能超过30个字'
    }
    if (duty && duty.length > 30) {
        return '您的职务不能超过30个字'
    }

    let phoneReg = /^[1-2][0-9]{10}$/
    let phone = $('.phoneInput').val()
    if (!phoneReg.test(phone)) {
        return '请输入合法的手机号'
    }

    let emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    let email = $('.emailInput').val()
    if (!!(email)) {
        if (!emailReg.test(email)) {
            return '请输入合法的邮箱'
        }
    }

    let sceneDesc = $('.sceneDescInput').val()
    if (sceneDesc && sceneDesc.length > 500) {
        return '您的使用场景不能超过500个字'
    }

    let knowChannel = $('.channelInput').val()
    if (knowChannel && knowChannel.length > 30) {
        return '您的获知渠道不能超过30个字'
    }

    return {
        code: "0", res: {
            orgName,
            name,
            duty,
            phone,
            email,
            sceneDesc,
            knowChannel
        }
    }
}

function _buttonCheck () {
    function buttonStyle () {
        let orgName = $('.orgNameInput').val();
        let name = $('.nameInput').val();
        let duty = $('.dutyInput').val();
        let phone = $('.phoneInput').val();
        if (!!orgName && !!name && !!duty && !!phone) {
            $('.summitBtn').removeClass('disable')
        } else {
            $('.summitBtn').addClass('disable')
        }
    }

    buttonStyle()

    $(document).on("input", '.orgNameInput', function (e) {
        buttonStyle()
    });
    $(document).on("input", '.nameInput', function (e) {
        buttonStyle()
    });

    $(document).on("input", '.dutyInput', function (e) {
        buttonStyle()
    });
    $(document).on("input", '.phoneInput', function (e) {
        buttonStyle()
    });
    // $(document).on("input", '.emailInput', function (e) {
    //
    // });
    // $(document).on("input", '.sceneDescInput', function (e) {
    //
    // });
}



// WEBPACK FOOTER //
// ./src/pages/index/dialog.js